import type {MouseEvent} from 'react'
import Icon, {type TIconName} from '../icon'
import {TooltipStyled} from '../tooltipCustom'
import './styles.css'

type IconButtonProps = {
  icon?: TIconName
  sizeButton?: string
  iconColor?: string
  iconSize?: string
  borderColor?: string
  tooltip?: string
  text?: string
  disabled?: boolean
  noBorder?: boolean
  /** Persistent selected state — applies the grey "selected" fill. */
  active?: boolean
  onClick?: (e: MouseEvent<HTMLDivElement>) => void
  tooltipPosition?: 'bottom' | 'right' | 'left' | 'top'
}

export default function IconButton({
  icon,
  iconColor = 'initial',
  iconSize = '1.5rem',
  borderColor = 'black',
  onClick,
  tooltip = '',
  tooltipPosition = 'bottom',
  sizeButton = '40px',
  text = '',
  noBorder = false,
  active = false,
  disabled = false,
}: IconButtonProps) {
  return tooltip ? (
    <TooltipStyled title={tooltip} placement={tooltipPosition}>
      <div
        className={`IconClassic ${onClick ? 'IconButton' : ''}${active ? ' active' : ''}`}
        style={{
          width: sizeButton,
          height: sizeButton,
          overflow: 'hidden',
          opacity: disabled ? 0.5 : 1.0,
          pointerEvents: disabled ? 'none' : 'auto',
          border: noBorder ? 'none' : `1px solid ${borderColor}`,
        }}
        onClick={onClick}>
        {!icon ? (
          <div
            style={{
              color: iconColor,
              fontWeight: 'bold',
              fontSize: 16,
            }}>
            {text}
          </div>
        ) : (
          <Icon type={icon} color={iconColor} size={iconSize} />
        )}
      </div>
    </TooltipStyled>
  ) : (
    <div
      className={`IconClassic ${onClick ? 'IconButton' : ''}${active ? ' active' : ''}`}
      style={{
        width: sizeButton,
        height: sizeButton,
        overflow: 'hidden',
        opacity: disabled ? 0.5 : 1.0,
        pointerEvents: disabled ? 'none' : 'auto',
        border: noBorder ? 'none' : `1px solid ${borderColor}`,
      }}
      onClick={onClick}>
      {!icon ? (
        <div
          style={{
            color: iconColor,
            fontWeight: 'bold',
            fontSize: 16,
          }}>
          {text}
        </div>
      ) : (
        <Icon type={icon} color={iconColor} size={iconSize} />
      )}
    </div>
  )
}
